const categories = [
  "All",
  "Business",
  "National",
  "Business  ",
  "Sports",
  "World",
  "Politics",
  "Technology",
  "Startup",
  "Entertainment",
  "Science",
];

export default categories;
